import { roundToSignificant } from "utils/roundToSignificant";
import { DataTableStoreState } from "../store/DataTableProvider.types";
import { EuiIcon, EuiText } from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";

interface DataTableComputeCreditsProps {
  selectedTable: DataTableStoreState["tables"][number];
}

export const DataTableComputeCredits = ({
  selectedTable,
}: DataTableComputeCreditsProps) => {
  // get total compute credits from selected table rows
  const totalComputeCredits = roundToSignificant(
    selectedTable?.rows.reduce((acc, row) => {
      const credits = row.task?.credits ?? 0;
      return acc + credits;
    }, 0),
  );
  return (
    <Tooltip content={`${totalComputeCredits} compute credits used`}>
      <EuiText style={{ marginRight: "5px" }} size="s" color="subdued">
        <EuiIcon
          type="compute"
          style={{ marginRight: "5px", verticalAlign: "text-bottom" }}
        />
        {totalComputeCredits}
      </EuiText>
    </Tooltip>
  );
};
